
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class IsyeriBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IsyeriBasvuruSave";
    super(baseUrl);
  }


  saveIsyeriBasvuruBasvuruSave(request: IsyeriBasvuruSaveRequest){
    
    return this.post("", request, true);
   
  }

}
export default new IsyeriBasvuruAPI();

class IsyeriBasvuruSaveRequest {
    basvuruTuruId: number;
    IacRuhsatBasvuruTuruId:number;
    sicilKodu: number;
    mahalleKodu?: number;
    caddeSokakKodu?: number;
    kapiNo?: number;
    altKapiNo?: string;
    daireNo?: number;
    altDaireNo?: string;
    siteApartmanAdi?: string;
    pafta?: string;
    ada?: number;
    parsel?: number;
    vergiDairesiAdi?: string;
    vergiDairesiNo?: number;
    ticaretSicilNo?: number;
    ustalikBelgeNo?: string;
    isyeriSinifiKodu?: number;
    binaKullanimTuruKodu?: number;
    isyeriKonumuKodu?: number;
    mulkiyetDurumuKodu?: number;
    acikAlanM2?: number;
    kapaliAlanM2?: number;
    yazAcilisSaat?: string;
    yazKapanisSaat?: string;
    kisAcilisSaat?: string;
    kisKapanisSaat?: string;
    egitimUzaklik?: number;
    dershaneUzaklik?: number;
    ogrenciYurduUzaklik?: number;
    ibadethaneUzaklik?: number;
    aciklama?: string;
    captchaToken?: string;

    constructor(
        basvuruTuruId: number,
        IacRuhsatBasvuruTuruId:number,
        sicilKodu: number,
        vergiDairesiAdi?: string,
        vergiDairesiNo?: number,
        mahalleKodu?: number,
        caddeSokakKodu?: number,
        kapiNo?: number,
        altKapiNo?: string,
        daireNo?: number,
        altDaireNo?: string,
        siteApartmanAdi?: string,
        pafta?: string,
        ada?: number,
        parsel?: number,
        ticaretSicilNo?: number,
        ustalikBelgeNo?: string,
        isyeriSinifiKodu?: number,
        binaKullanimTuruKodu?: number,
        isyeriKonumuKodu?: number,
        mulkiyetDurumuKodu?: number,
        acikAlanM2?: number,
        kapaliAlanM2?: number,
        yazAcilisSaat?: string,
        yazKapanisSaat?: string,
        kisAcilisSaat?: string,
        kisKapanisSaat?: string,
        egitimUzaklik?: number,
        dershaneUzaklik?: number,
        ogrenciYurduUzaklik?: number,
        ibadethaneUzaklik?: number,
        aciklama?: string,
        captchaToken?: string
    ) {
        this.basvuruTuruId = basvuruTuruId;
        this.IacRuhsatBasvuruTuruId = IacRuhsatBasvuruTuruId;
        this.sicilKodu = sicilKodu;
        this.vergiDairesiAdi = vergiDairesiAdi;
        this.vergiDairesiNo = vergiDairesiNo;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.kapiNo = kapiNo;
        this.altKapiNo = altKapiNo;
        this.daireNo = daireNo;
        this.altDaireNo = altDaireNo;
        this.siteApartmanAdi = siteApartmanAdi;
        this.pafta = pafta;
        this.ada = ada;
        this.parsel = parsel;
        this.ticaretSicilNo = ticaretSicilNo;
        this.ustalikBelgeNo = ustalikBelgeNo;
        this.isyeriSinifiKodu = isyeriSinifiKodu;
        this.binaKullanimTuruKodu = binaKullanimTuruKodu;
        this.isyeriKonumuKodu = isyeriKonumuKodu;
        this.mulkiyetDurumuKodu = mulkiyetDurumuKodu;
        this.acikAlanM2 = acikAlanM2;
        this.kapaliAlanM2 = kapaliAlanM2;
        this.yazAcilisSaat = yazAcilisSaat;
        this.yazKapanisSaat = yazKapanisSaat;
        this.kisAcilisSaat = kisAcilisSaat;
        this.kisKapanisSaat = kisKapanisSaat;
        this.egitimUzaklik = egitimUzaklik;
        this.dershaneUzaklik = dershaneUzaklik;
        this.ogrenciYurduUzaklik = ogrenciYurduUzaklik;
        this.ibadethaneUzaklik = ibadethaneUzaklik;
        this.aciklama = aciklama;
        this.captchaToken = captchaToken;
    }
}
export { IsyeriBasvuruSaveRequest };